import Api, { apiStart, apiEnd, apiError, requestSuccess, requestFail } from "@Api";
import store from "@Redux";
import {
	GET_CHATS,
	SET_SEARCH_IN_CHAT,
	CLEAR_SEARCH_IN_CHAT,
	SET_CURRENT_CHAT,
	TAKE_CHAT,
	TAG_CHAT,
	FREE_CHAT,
	CLOSE_CHAT,
	TRANSFER_CHAT,
	SHEDULE_CHAT,
	GET_REMAINING_MESSAGES,
	RECEIVE_MESSAGE,
	MESSAGE_LOCAL,
	MESSAGE_SENT,
	MESSAGE_FAIL,
	SET_REPLY,
	REMOVE_REPLY,
	CHAT_TAKEN,
	CHAT_FREED,
	CHAT_TRANSFERRED,
	CHAT_CLOSED,
	UPDATE_CHAT,
	GET_CHATS_H,
	GET_CHAT_DETAILS,
	TOGGLE_VIEW_AUTOGESTION,
	UPDATE_CONTACT,
	SET_CURRENT_CHATH,
} from "@Actions/types";
import { compressImage } from "@Utils/functionality";
import { canViewChat } from "@Utils";
import { includes, isEmpty, find } from "lodash";
import FormData from "form-data";

// Internal
export function setSearchMessages() {
	return (dispatch) => {
		dispatch(requestSuccess(SET_SEARCH_IN_CHAT));
	};
}

export function clearSearchMessages() {
	return (dispatch) => {
		dispatch(requestSuccess(CLEAR_SEARCH_IN_CHAT));
	};
}

export function toggleViewAutogestion() {
	return (dispatch) => {
		dispatch(requestSuccess(TOGGLE_VIEW_AUTOGESTION));
	};
}

export function setCurrentChat(chatId, isHistoric) {
	return (dispatch) => {
		const type = isHistoric ? SET_CURRENT_CHATH : SET_CURRENT_CHAT;
		dispatch(requestSuccess(type, { chatId, isHistoric }));
	};
}

export function setReply(message) {
	return (dispatch) => {
		dispatch(requestSuccess(SET_REPLY, message));
	};
}

export function removeReply() {
	return (dispatch) => {
		dispatch(requestSuccess(REMOVE_REPLY));
	};
}

// From Socket
export function receiveMsg(data) {
	return (dispatch) => {
		const incomingMessages = Array.isArray(data?.message) ? data.message : [data?.message];
		incomingMessages.forEach((msg) => {
			if (!msg || msg.type !== "JSON" || typeof msg.text !== "string") return;
			let parsed = null;
			try {
				parsed = JSON.parse(msg.text);
			} catch (err) {
				parsed = null;
			}
			if (parsed?.type === "form" && Array.isArray(parsed.content)) {
				const flowData = {};
				parsed.content.forEach((field) => {
					if (field.name) flowData[field.name] = field.value;
				});
			}
		});
		if (canViewChat({ chatUserId: data.chat.userId, chatGroupId: data.chat.groupId })) {
			dispatch(requestSuccess(RECEIVE_MESSAGE, data));
		}
	};
}

export function chatTaken(data) {
	return async (dispatch) => {
		const { chats } = store.getState().chats;
		const chatInStore = find(chats, { id: data.chat.id });
		if (canViewChat({ chatUserId: data.chat.userId, chatGroupId: data.chat.groupId }) && chatInStore) {
			dispatch(requestSuccess(UPDATE_CHAT, data));
		} else {
			dispatch(requestSuccess(CHAT_TAKEN, data));
		}
	};
}

export function chatFreed(data) {
	return (dispatch) => {
		const { chats } = store.getState().chats;
		const chatInStore = find(chats, { id: data.chat.id });
		if (canViewChat({ chatUserId: data.chat.userId, chatGroupId: data.chat.groupId }) && chatInStore) {
			dispatch(requestSuccess(UPDATE_CHAT, data));
		} else {
			dispatch(requestSuccess(CHAT_FREED, data));
		}
	};
}

export function chatTransferred(data) {
	return (dispatch) => {
		const { chats } = store.getState().chats;
		const chatInStore = find(chats, { id: data.chat.id });
		const canView = canViewChat({ chatUserId: data.chat.userId, chatGroupId: data.chat.groupId });
		if (canView && chatInStore) {
			dispatch(requestSuccess(UPDATE_CHAT, data));
		} else if (canView && !chatInStore) {
			dispatch(requestSuccess(CHAT_TRANSFERRED, data));
		} else if (!canView && chatInStore) {
			dispatch(requestSuccess(TRANSFER_CHAT, { ...data, withRemoveCurrent: chatInStore.id === data.chat.id }));
		}
	};
}

export function chatTagged(data) {
	return async (dispatch) => {
		dispatch(requestSuccess(UPDATE_CHAT, { chat: data }));
	};
}

export function chatClosed(data) {
	return async (dispatch) => {
		dispatch(requestSuccess(CHAT_CLOSED, data));
	};
}

export function contactUpdated(data) {
	return async (dispatch) => {
		dispatch(requestSuccess(UPDATE_CONTACT, data));
	};
}

// From Api
export function getChatsAndMessages() {
	return (dispatch) => {
		dispatch(apiStart());
		Api.get(`/chats`)
			.then((response) => {
				if (response.data.success) {
					dispatch(requestSuccess(GET_CHATS, response.data.data));
					dispatch(apiEnd());
				} else {
					dispatch(apiEnd());
					dispatch(requestFail(response.data.message));
				}
			})
			.catch((error) => {
				dispatch(apiEnd());
				dispatch(apiError(error.message));
			});
	};
}

export function getChatDetails(chatId, isHistoric = false) {
	return (dispatch) => {
		const url = isHistoric ? `/chatsh/${chatId}` : `/chats/${chatId}`;
		Api.get(url)
			.then((response) => {
				if (response.data.success) {
					dispatch(requestSuccess(GET_CHAT_DETAILS, { chat: response.data.data.chat, isHistoric }));
				}
			})
			.catch((error) => {
				dispatch(apiError(error.message));
			});
	};
}

export function getChatsHistoric(filters) {
	return (dispatch) => {
		dispatch(apiStart());
		Api.post(`/chats/searchHistory`, filters)
			.then((response) => {
				if (response.data.success) {
					dispatch(requestSuccess(GET_CHATS_H, response.data.data));
					dispatch(apiEnd());
				} else {
					dispatch(apiEnd());
					dispatch(requestFail(response.data.message));
				}
			})
			.catch((error) => {
				dispatch(apiEnd());
				dispatch(apiError(error.message));
			});
	};
}

export function takeChat(chatId) {
	return (dispatch) => {
		dispatch(apiStart());
		Api.post("/chats/takeChat", {
			chatId,
		})
			.then((response) => {
				if (response.data.success) {
					dispatch(requestSuccess(TAKE_CHAT, response.data.data));
					dispatch(apiEnd());
				} else {
					dispatch(apiEnd());
					if (!isEmpty(response.data.data)) {
						dispatch(requestSuccess(UPDATE_CHAT, { ...response.data.data, current: "add" }));
					} else {
						dispatch(requestFail(response.data.message));
					}
				}
			})
			.catch((error) => {
				dispatch(apiEnd());
				dispatch(apiError(error));
			});
	};
}

export function freeChat(chatId) {
	return (dispatch) => {
		dispatch(apiStart());
		Api.post("/chats/freeChat", {
			chatId,
		})
			.then((response) => {
				if (response.data.success) {
					dispatch(requestSuccess(FREE_CHAT, response.data.data));
					dispatch(apiEnd());
				} else {
					dispatch(apiEnd());
					if (!isEmpty(response.data.data)) {
						dispatch(requestSuccess(UPDATE_CHAT, { ...response.data.data, current: "remove" }));
					} else {
						dispatch(requestFail(response.data.message));
					}
				}
			})
			.catch((error) => {
				dispatch(apiEnd());
				dispatch(apiError(error));
			});
	};
}

export function tagChat(chatId, tagIds, onSucess = () => {}) {
	return (dispatch) => {
		dispatch(apiStart());
		Api.post("chats/tagChat", {
			chatId,
			tagIds,
		})
			.then((response) => {
				if (response.data.success) {
					dispatch(requestSuccess(TAG_CHAT, response.data.data));
					onSucess(response.data.data);
					dispatch(apiEnd());
				} else {
					dispatch(apiEnd());
					dispatch(requestFail(response.data.message));
				}
			})
			.catch((error) => {
				dispatch(apiEnd());
				dispatch(apiError(error));
			});
	};
}

export function sheduleChat(chatId, shedule) {
	return (dispatch) => {
		dispatch(apiStart());
		Api.post("chats/scheduleChat", {
			chatId,
			...shedule,
		})
			.then((response) => {
				if (response.data.success) {
					dispatch(requestSuccess(SHEDULE_CHAT, chatId));
					dispatch(apiEnd());
				} else {
					dispatch(apiEnd());
					dispatch(requestFail(response.data.message));
				}
			})
			.catch((error) => {
				dispatch(apiEnd());
				dispatch(apiError(error));
			});
	};
}

export function closeChat(chatId, channelCid, withMsg = false) {
	return (dispatch) => {
		dispatch(apiStart());
		Api.post("/chats/closeChat", {
			chatId,
			withMsg,
		})
			.then(async (response) => {
				if (response.data.success) {
					dispatch(requestSuccess(CLOSE_CHAT, channelCid));
					dispatch(apiEnd());
				} else {
					dispatch(apiEnd());
					dispatch(requestFail(response.data.message));
				}
			})
			.catch((error) => {
				dispatch(apiEnd());
				dispatch(apiError(error));
			});
	};
}

export function transferChat(
	chatId,
	transferUserId = null,
	transferGroupId = null,
	transferToSelf = false,
	keepUser = false,
	keepGroup = true,
	isMultiple = false
) {
	return (dispatch) => {
		dispatch(apiStart());
		const url = isMultiple ? "/chats/transferChat/multiple" : "/chats/transferChat";
		const body = {
			transferUserId,
			transferGroupId,
			keepUser,
			keepGroup,
		};

		if (isMultiple) {
			body.chatIds = chatId;
		} else {
			body.chatId = chatId;
		}

		Api.post(url, body)
			.then(async (response) => {
				if (response.data.success) {
					if (isMultiple) {
						dispatch(apiEnd());
					} else {
						const { permissions } = store.getState().user;
						const { data, removeChat } = response.data.data;
						if (permissions.allowViewAllChats || !removeChat) {
							dispatch(requestSuccess(UPDATE_CHAT, { ...data, current: transferToSelf ? "add" : "remove" }));
						} else {
							dispatch(requestSuccess(TRANSFER_CHAT, { ...data, withRemoveCurrent: true }));
						}
						dispatch(apiEnd());
					}
				} else {
					dispatch(apiEnd());
					dispatch(requestFail(response.data.message));
				}
			})
			.catch((error) => {
				dispatch(apiEnd());
				dispatch(apiError(error));
			});
	};
}

export function getChatRemainingMessages({
	channelCid,
	chatId,
	offset,
	isLoading,
	isHistoric = false,
	groupByChat = false,
	messageId = null,
	startingMessageId,
}) {
	return (dispatch) => {
		return Api.post("/chats/getRemainingMessages", {
			channelCid,
			chatId,
			offset,
			groupByChat,
			messageId,
			startingMessageId,
		})
			.then((response) => {
				if (response.data.success) {
					dispatch(requestSuccess(GET_REMAINING_MESSAGES, { chatId, messages: response.data.data, isHistoric }));
					isLoading(false);
					return response.data.data;
				}
				isLoading(false);
				dispatch(requestFail(response.data.message));
				return [];
			})
			.catch((error) => {
				isLoading(false);
				dispatch(apiError(error));
				return [];
			});
	};
}

const validateMessageContent = (text, state) => {
	const { blackListKeyWords } = state.company.settings;
	if (!isEmpty(blackListKeyWords) && !isEmpty(text)) {
		const blockedWords = blackListKeyWords.filter((keyword) => {
			const escapedKeyword = keyword.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
			const regex = new RegExp(`\\b${escapedKeyword}\\b`, "i");
			return regex.test(text);
		});
		return blockedWords.length > 0 ? blockedWords.join(", ") : null;
	}
	return null;
};

export function sendMessage({ message, file = null, newChat = false, listRef = null }) {
	return async (dispatch, getState) => {
		const blockedWord = validateMessageContent(message.text, getState());
		if (blockedWord) {
			Api.post("/chats/actions", { chatId: message.chatId, keywords: blockedWord }).then((response) => {
				if (response.data.success) {
					dispatch(requestSuccess(UPDATE_CHAT, { chat: response.data.data }));
				}
			});
			dispatch(apiError(`Mensaje no enviado. Contiene palabras prohibidas: "${blockedWord}"`));
			return false;
		}

		const hasAttachment = includes(["Image", "Audio", "Video", "Document", "Note"], message.type);
		dispatch(requestSuccess(MESSAGE_LOCAL, message));
		if (listRef && listRef.current) {
			listRef.current.scrollToBottom();
		}
		const form = new FormData();
		form.append("message", JSON.stringify(message));
		form.append("newChat", newChat);
		if (hasAttachment && file) {
			let processedFile = file;
			if (includes(["Image", "Note"], message.type)) {
				processedFile = await compressImage(file);
			}
			form.append("file", processedFile);
		}
		Api.post("/chats/sendMessage", form)
			.then((response) => {
				if (response.data.success) {
					dispatch(requestSuccess(MESSAGE_SENT, response.data.data));
				} else {
					dispatch(requestFail(response.data.message));
				}
			})
			.catch((error) => {
				dispatch(apiError(MESSAGE_FAIL, { error: error.message, chatMsg: message }));
			});
		return true;
	};
}

export function sendEmailMessage({ message, attachments = [], newChat = false, listRef = null }) {
	return async (dispatch, getState) => {
		const { id, chatId, channel, channelCid, text } = message;

		const blockedWord = validateMessageContent(text, getState());
		if (blockedWord) {
			Api.post("/chats/actions", { chatId: message.chatId, keywords: blockedWord }).then((response) => {
				if (response.data.success) {
					dispatch(requestSuccess(UPDATE_CHAT, { chat: response.data.data }));
				}
			});
			dispatch(apiError(`Mensaje no enviado. Contiene palabras prohibidas: "${blockedWord}"`));
			return false;
		}

		dispatch(requestSuccess(MESSAGE_LOCAL, message));
		if (listRef && listRef.current) {
			listRef.current.scrollToBottom();
		}
		Api.post("/emails/sendEmail", {
			id,
			chatId,
			channel,
			channelCid,
			text,
			attachments,
			newChat,
		})
			.then((response) => {
				if (response.data.success) {
					dispatch(requestSuccess(MESSAGE_SENT, response.data.data));
				} else {
					dispatch(requestFail(response.data.message));
				}
			})
			.catch((error) => {
				dispatch(apiError(MESSAGE_FAIL, { error: error.message, chatMsg: message }));
			});
		return true;
	};
}

export function updateChatData(chatData) {
	return (dispatch) => {
		dispatch(requestSuccess(UPDATE_CHAT, { chat: chatData }));
	};
}
